import React, { memo } from 'react';
import CTABarSmall, { CTABarSmallProps } from './CTABarSmall';
import Container from '../Utils/Container/Container';
import Grid from '../Utils/Grid/Grid';
import Col from '../Utils/Col/Col';

const CTABarSmallBlok: React.FC<CTABarSmallProps> = ({ blok }) => {
  return (
    <Container>
      <Grid>
        <Col>
          <CTABarSmall blok={blok} />
        </Col>
      </Grid>
    </Container>
  );
};

export default memo(CTABarSmallBlok);
